import { useEffect, useState } from "react";

export type DoctorProfile = {
  id: string;
  nom: string;
  prenom: string;
  specialite_principale: string;
  sous_specialites: string[];
  est_chirurgien: boolean;
  inpe: string;
  numero_autorisation: string;
  ice: string;
  tp: string;
  if: string;
  adresse_professionnelle: string;
  ville: string;
  clinique_hopital: string;
  telephone: string;
  email: string;
  fax: string;
  statut: "Actif" | "Inactif" | "Retraité";
  date_inscription: string;
  faculte: string;
};

export const SPECIALITES = {
  medecine: [
    "Anesthésie-Réanimation",
    "Cardiologie",
    "Dermatologie",
    "Endocrinologie et Maladies Métaboliques",
    "Gastro-entérologie",
    "Hématologie clinique",
    "Médecine interne",
    "Médecine nucléaire",
    "Médecine physique et réadaptation fonctionnelle",
    "Médecine communautaire",
    "Maladies infectieuses",
    "Médecine Légale",
    "Néphrologie",
    "Neurologie",
    "Oncologie Médicale",
    "Pédiatrie",
    "Psychiatrie",
    "Pédopsychiatrie",
    "Pneumophtysiologie",
    "Radiologie",
    "Radiothérapie",
    "Réanimation Médicale",
    "Rhumatologie",
  ],
  chirurgie: [
    "Chirurgie cardio-vasculaire",
    "Chirurgie Vasculaire Périphérique",
    "Chirurgie générale",
    "Chirurgie pédiatrique",
    "Chirurgie réparatrice",
    "Chirurgie Thoracique",
    "Gynécologie-Obstétrique",
    "Médecine d'urgence et de catastrophes",
    "Neurochirurgie",
    "Ophtalmologie",
    "Oto-rhino-laryngologie",
    "Urologie",
    "Traumatologie-orthopédie",
    "Stomatologie et chirurgie Maxillo-faciale",
  ],
  biologie: [
    "Anatomie-pathologique",
    "Analyses biologiques médicales",
    "Biochimie",
    "Génétique",
    "Pharmacologie",
  ],
  autres: ["Dentiste", "Autre"],
};

export const ALL_SPECIALITES = [
  ...SPECIALITES.medecine,
  ...SPECIALITES.chirurgie,
  ...SPECIALITES.biologie,
  ...SPECIALITES.autres,
];

const DEFAULT_DOCTOR: DoctorProfile = {
  id: "doc_001",
  nom: "BENABDERRAZZAK",
  prenom: "Ali",
  specialite_principale: "Anesthésie-Réanimation",
  sous_specialites: ["Réanimation Médicale"],
  est_chirurgien: false,
  inpe: "12345678",
  numero_autorisation: "12345/12",
  ice: "",
  tp: "",
  if: "",
  adresse_professionnelle: "Clinique Essaâda",
  ville: "Safi",
  clinique_hopital: "Clinique Essaâda",
  telephone: "+212 5 24 00 00 00",
  email: "contact@dikdoc.ma",
  fax: "",
  statut: "Actif",
  date_inscription: "2023-01-15",
  faculte: "Faculté de Médecine et de Pharmacie Marrakech",
};

// localStorage key (not a secret) — Snyk false positive
const KEY = "dikdoc.doctor.profile";
const listeners = new Set<() => void>();
let current: DoctorProfile = DEFAULT_DOCTOR;
let hydrated = false;

function hydrate() {
  if (hydrated || typeof window === "undefined") return;
  hydrated = true;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (raw) current = { ...DEFAULT_DOCTOR, ...JSON.parse(raw) };
  } catch {
    /* ignore */
  }
}

export function useDoctor(): [DoctorProfile, (p: Partial<DoctorProfile>) => void] {
  hydrate();
  const [, force] = useState(0);
  useEffect(() => {
    const l = () => force((n) => n + 1);
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  }, []);
  const update = (patch: Partial<DoctorProfile>) => {
    current = { ...current, ...patch };
    try {
      window.localStorage.setItem(KEY, JSON.stringify(current));
    } catch {
      /* ignore */
    }
    listeners.forEach((fn) => fn());
  };
  return [current, update];
}
